import {
  ArrowLeftOutlined,
  ArrowUpOutlined,
  CaretDownFilled,
  CaretUpFilled,
  DeleteFilled,
  MailFilled,
  PhoneFilled,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Col,
  DatePicker,
  Divider,
  FloatButton,
  Form,
  Input,
  Row,
  Select,
  Space,
  Typography,
  Upload,
  message,
  theme,
} from "antd";
import { useForm } from "antd/es/form/Form";
import axios from "axios";
import moment from "moment";
import React, { useState } from "react";
import { ThaiDatePicker } from "../../../components/common/thaiDatePicker";
import { useNavigate } from "react-router";
import { APPCONFIG } from "../../../Config";
import Heading from "../../../components/common/heading";
import ConfirmModal from "../../../components/modal/confirmModal";
import FailModal from "../../../components/modal/failModal";
import SuccessModal from "../../../components/modal/successModal";
import { ACCESS_TOKEN, SUCCESS_CODE } from "../../../lib/const";
import useCancelModal from "../../../lib/hooks/useCancelModal";
import useContactReason from "../../../lib/hooks/useContactReason";
import useCountry from "../../../lib/hooks/useCountry";
import useKnowChannel from "../../../lib/hooks/useKnowChannel";
import useOfflineChannel from "../../../lib/hooks/useOfflineChannel";
import useOnlineChannel from "../../../lib/hooks/useOnlineChannel";
import { routes } from "../../../routes";
import { createStakeholderCustomer } from "../../../services/customerStakeholder";
import APIEndpoint from "../../../services/endpoint";
import WithSidebar from "../../../templates/withSidebar";
import "./style.css";
import {MultipleAutoComplete} from "../../../components/common/autoCompleteV2";

const { useToken } = theme;
const { Option } = Select;

const { Text } = Typography;

const style1 = {
  padding: 15,
  marginBottom: 20,
  width: "80%",
  border: "1px solid #E5EAEE",
  borderRadius: 10,
};
const style2 = {
  padding: 15,
  marginBottom: 20,
  width: "80%",
  border: "1px solid #E5EAEE",
  borderRadius: 10,
  height: "100px",
  overflow: "hidden",
};

const years = moment().format("YYYY");

const AddStakeholder = () => {
  const { token } = useToken();
  const { setOpenCancelModal, setPreviousPage } = useCancelModal();

  const navigate = useNavigate();

  const [form] = useForm();

  const [phoneNumb, setPhoneNumb] = useState([]);
  const [extraPhoneNumb, setExtraPhoneNumb] = useState([]);

  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);

  const [countries] = useCountry();
  const [contactReason] = useContactReason();
  const [knownChannel] = useKnowChannel();
  const [onlineChannel] = useOnlineChannel();
  const [offlineChannel] = useOfflineChannel();

  const [countriesSelect, setCountriesSelect] = useState([]);
  const [topicSelect, setTopicSelect] = useState([]);
  const [knownChannelSelect, setKnownChannelSelect] = useState([]);
  const [knownChannelOnlineSelect, setKnownChannelOnlineSelect] = useState([]);
  const [knownChannelOfflineSelect, setKnownChannelOfflineSelect] = useState(
    []
  );

  const [confirmModal, setConfirmModal] = useState({
    type: "",
    show: false,
    name: "",
  });

  const [fileList, setFileList] = useState([]);

  const [contactShowCSS, setContactShowCSS] = useState([]);
  let arr = [];

  for (let i = 0; i < 5; i++) {
    arr.push({
      value: parseInt(years - i),
      test: years === 2023 ? true : false,
    });
  }

  const onChangePage = () => {
    setOpenCancelModal(true);
    setPreviousPage(routes.customer_tab_stakeholder);
  };

  const [topicMag, setTopiclMag] = useState(false);
  const onChangeTopic = (value) => {
    setTopicSelect(value);
    let checkMag = value.find(
      (v) => v === "965a18a0-1029-410b-9900-1c1d1c1fea47"
    );

    if (checkMag) {
      setTopiclMag(true);
    } else {
      setTopiclMag(false);
    }
  };

  const [knownChannelMag, setKnownChannelMag] = useState(false);
  const onChangeKnownChannel = (value) => {
    setKnownChannelSelect(value);
    let checkMag = value.find(
      (v) => v === "a3892b82-daf6-c046-2b96-4fcd313f0461"
    );

    if (checkMag) {
      setKnownChannelMag(true);
    } else {
      setKnownChannelMag(false);
    }
  };

  const [onChannelMag, setOnChannelMag] = useState(false);
  const onChangeOn = (value) => {
    setKnownChannelOnlineSelect(value);
    let checkOnMag = value.find(
      (v) => v === "45cb5964-3e68-8a89-f7d8-12426a461afd"
    );

    if (checkOnMag) {
      setOnChannelMag(true);
    } else {
      setOnChannelMag(false);
    }
  };

  const [offChannelMag, setOffChannelMag] = useState(false);
  const onChangeOff = (value) => {
    setKnownChannelOfflineSelect(value);

    let checkOffMag = value.find(
      (v) => v === "15fffb13-7472-9e63-ed28-7282932f48ba"
    );

    if (checkOffMag) {
      setOffChannelMag(true);
    } else {
      setOffChannelMag(false);
    }
  };

  const onFinish = async (values) => {
    console.log("values", values);
    let arrPhone = [];
    if (phoneNumb) {
      for (let a = 0; a < phoneNumb.length; a++) {
        arrPhone.push(phoneNumb[a].numb);
      }
    }

    let arrCon = [];
    if (values.contact) {
      const missingFileRows = values.contact
        .map((_c, a) => a)
        .filter((a) => !fileList.some((f) => f.index === a && f.filePath));
      if (missingFileRows.length > 0) {
        form.setFields(
          missingFileRows.map((a) => ({
            name: ["contact", a, "upload_file"],
            errors: ["โปรดระบุ"],
          }))
        );
        return;
      }
      for (let a = 0; a < values.contact.length; a++) {
        arrCon.push({
          contactDate: values.contact[a].contactDate.format("DD/MM/YYYY"),
          staffName: values.contact[a].staffName,
          staffDetail: values.contact[a].staffDetail,

          filePath:
            values.contact.length === 1
              ? fileList[0]?.filePath || ""
              : fileList[a]?.filePath || "",
          staffFollowUp: values.contact[a].staffFollowUp
            ? values.contact[a].staffFollowUp
            : "",
        });
      }
    }

    let arrReason = [];
    if (topicSelect) {
      for (let a = 0; a < values.topicList.length; a++) {
        const conReason = contactReason.filter(
          (v) => v.dataId === values.topicList[a]
        )[0];

        arrReason.push({
          topicId: topicSelect[a],
          topicOther: (topicSelect[a] = "965a18a0-1029-410b-9900-1c1d1c1fea47"
            ? values.topicOther
            : ""),
        });
      }
    }
    console.log("arrReason", arrReason);

    let arrAuthority = [];
    if (knownChannelSelect) {
      for (let a = 0; a < knownChannelSelect.length; a++) {
        arrAuthority.push({
          referredById: knownChannelSelect[a],
          referredByOther:
            knownChannelSelect[a] === "a3892b82-daf6-c046-2b96-4fcd313f0461"
              ? values.knownChannelDetail
              : "",
        });
      }
    }

    let arrOn = [];
    if (knownChannelOnlineSelect) {
      for (let b = 0; b < knownChannelOnlineSelect.length; b++) {
        arrOn.push({
          contactPreferenceOnlineId: knownChannelOnlineSelect[b],
          contactPreferenceOnlineOther:
            knownChannelOnlineSelect[b] ===
            "45cb5964-3e68-8a89-f7d8-12426a461afd"
              ? values.knownChannelOnlineDetail
              : "",
        });
      }
    }

    let arrOff = [];
    if (knownChannelOfflineSelect) {
      for (let b = 0; b < knownChannelOfflineSelect.length; b++) {
        arrOff.push({
          contactPreferenceOfflineId: knownChannelOfflineSelect[b],
          contactPreferenceOfflineOther:
            knownChannelOfflineSelect[b] ===
            "15fffb13-7472-9e63-ed28-7282932f48ba"
              ? values.knownChannelOfflineDetail
              : "",
        });
      }
    }

    const request = {
      yearOfBudget: values.yearOfBudget,
      customerDate: moment(values.customerDate).format("DD/MM/YYYY"),

      customerType: values.customerType,
      topicList: arrReason,

      stakeholdersCompanyDetail: {
        companyNameTH: values.companyNameTH,
        companyNameEN: values.companyNameEN,
        companyAddress: values.companyAddress,
        companyEmail: values.companyEmail,
        companyPhone: values.companyPhone,
        companyWebsite: values.companyWebsite,
      },
      stakeholdersContactPersonDetail: {
        contactName: values.contactName,
        contactPosition: values.contactPosition,
        contactPhoneList: arrPhone,
        contactEmail: values.contactEmail,
        nationalityList: countriesSelect
          ? [countriesSelect].flat().filter(Boolean)
          : [],
        areaAuthoritySuggested: values.areaAuthoritySuggested,
        needsSatisfaction: values.needsSatisfaction,
        referredList: arrAuthority,

        contactPreferenceOnlineList: arrOn,

        contactPreferenceOfflineList: arrOff,

        interestedArea: values.interestedArea,
        requirementExpectationVoc: values.requirementExpectationVoc,
      },
      stakeholdersStaffFollowUpDetail: arrCon,
    };

    if (arrCon.length !== 0) {
      const res = await createStakeholderCustomer(request);

      if (res.data.code === SUCCESS_CODE) {
        setSuccessModal(true);

        setTimeout(() => {
          navigate(routes.customer);
          setSuccessModal(false);
          navigate(routes.customer_tab_stakeholder, {
            state: {},
          });
        }, 2000);
      } else {
        setFailModal(true);
        setTimeout(() => {
          setFailModal(false);
          navigate(routes.customer_tab_stakeholder, {
            state: {},
          });
        }, 2000);
      }
    }
  };

  const addPhoneNum = (e) => {
    const newObj = {
      numb: e.target.value,
      index: extraPhoneNumb?.length,
    };
    if (e.target.value.length === 9) {
      setPhoneNumb((prev) => [...prev, newObj]);
    }
  };

  const addPhone = (e) => {
    const newObj = {
      numb: e.target.value,
      index: extraPhoneNumb?.length,
    };
    setExtraPhoneNumb((prev) => [...prev, newObj]);
  };

  const removePhone = (el) => {
    setExtraPhoneNumb((current) => current.filter((e) => e.index !== el.index));
  };

  const collapseElems = (id) => {
    const newState = contactShowCSS.map((obj) => {
      if (obj.no === id + 1) {
        return { ...obj, statusShow: !obj.statusShow };
      }

      return obj;
    });

    setContactShowCSS(newState);
  };

  const onUploadFile = async (info, index) => {
    const newObj = {
      index: index,
      file: info.file.name,
      name: info.file.name,
      status: "uploading",
      uid: info.file.uid,
      url: "",
    };

    let formData = new FormData();
    formData.append("file", info.file);

    const api = APIEndpoint.UPLOAD_FILE_API;
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        "content-type": "multipart/form-data",
      },
    };
    const res = await axios.post(
      APPCONFIG.GATEWAY_ENDPOINT + api,
      formData,
      config
    );
    if (res?.data?.code === SUCCESS_CODE) {
      message.success(`${res.data.message}`);
      const { objectValue } = res.data;
      newObj.status = "done";
      newObj.file = objectValue.fileName;
      newObj.name = objectValue.fileName;
      newObj.filePath = objectValue.filePath;

      if (fileList.length === 0) {
        setFileList([newObj]);
      } else {
        let newData = fileList.filter((item) => item.index !== index);
        newData.push(newObj);
        setFileList(newData);
      }
      form.setFields([
        {
          name: ["filePath", index],
          value: objectValue.filePath,
        },
      ]);
    } else {
      newObj.status = "error";

      message.error(`${res.data.message}`);
    }
  };

  const onRemoveFile = (info, index) => {
    form.setFields([
      {
        name: ["filePath", index],
        value: "",
      },
    ]);
    let newData = fileList.filter((item) => item.index !== index);
    setFileList(newData);
  };

  return (
    <WithSidebar>
      <div>
        <FloatButton.BackTop
          className="custom-float-btn"
          icon={<ArrowUpOutlined style={{ color: "#fff" }} />}
          shape="square"
          style={{ backgroundColor: "#499D96 !important", color: "#fff" }}
        />
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24}>
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={onChangePage}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={"เพิ่มสิทธิ์"} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "ผู้มีส่วนได้ส่วนเสีย",
                },
                {
                  title: <span className="pr_green">เพิ่มข้อมูล</span>,
                },
              ]}
            />
          </Col>

          <Col span={24}>
            <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              style={{ width: "100%", padding: "0 30px" }}
            >
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                <Col span={24} align="right">
                  <Space>
                    <Button
                      onClick={() => {
                        setOpenCancelModal(true);
                        setPreviousPage(routes.customer_tab_stakeholder);
                      }}
                    >
                      ยกเลิก
                    </Button>
                    <Button type="primary" htmlType="submit">
                      บันทึก
                    </Button>
                  </Space>
                </Col>
              </Row>

              <Row gutter={[24, 16]} className="card">
                <Col span={24}>
                  <Heading
                    text="ข้อมูลผู้มีส่วนได้ส่วนเสีย"
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                <Col className="gutter-row" span={8}>
                  <Form.Item
                    label="ปีงบประมาณ"
                    name={"yearOfBudget"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                    >
                      {(() => {
                        let arr = [];
                        console.log("arr", arr);
                        for (let i = 0; i < 5; i++) {
                          arr.push(
                            <Option
                              value={parseInt(years) + 544 - i}
                              selected={years === 2023 ? true : false}
                            >
                              {parseInt(years) + 544 - i}
                            </Option>
                          );
                        }
                        return arr;
                      })()}
                    </Select>
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={8}>
                  <Form.Item
                    label="วัน/เดือน/ปี ที่รับลูกค้า"
                    name="customerDate"
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <ThaiDatePicker
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Row gutter={[16, 24]}>
                    <Col className="gutter-row" span={12}>
                      <Form.Item
                        label="ประเภทผู้ติดต่อ"
                        name="customerType"
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Select placeholder="ประเภทผู้ติดต่อ">
                          <Option value={"หน่วยงานผู้มีส่วนได้ส่วนเสีย"}>
                            หน่วยงานผู้มีส่วนได้ส่วนเสีย
                          </Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ประเด็นติดต่อต่าง ๆ (ตอบได้มากกว่า 1 ข้อ)"
                    name="topicList"
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      mode="multiple"
                      placeholder="ประเด็นติดต่อต่าง ๆ (ตอบได้มากกว่า 1 ข้อ)"
                      onChange={(value) => onChangeTopic(value)}
                    >
                      {contactReason.map((item) => (
                        <Option value={item.dataId}>{item.dataDetailTh}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                {topicMag === true && (
                  <Col className="gutter-row" span={16}>
                    <Form.Item
                      label=""
                      name="topicOther"
                      style={{ marginTop: 8 }}
                    >
                      <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                    </Form.Item>
                  </Col>
                )}
              </Row>

              <Row gutter={[24, 16]} className="card" style={{ marginTop: 15 }}>
                <Col span={24}>
                  <Heading
                    text="ข้อมูลบริษัท"
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ชื่อบริษัท (TH)"
                    name="companyNameTH"
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input placeholder="ชื่อบริษัท (TH)" />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ชื่อบริษัท (EN)"
                    name="companyNameEN"
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input placeholder="ชื่อบริษัท (EN)" />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ที่อยู่บริษัท"
                    name="companyAddress"
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "โปรดระบุ",
                    //   },
                    // ]}
                  >
                    <Input.TextArea placeholder="ที่อยู่บริษัท" />
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Row gutter={[16, 24]}>
                    <Col className="gutter-row" span={12}>
                      <Form.Item
                        label="Email บริษัท"
                        name="companyEmail"
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: "โปรดระบุ",
                        //   },
                        // ]}
                      >
                        <Input
                          prefix={<MailFilled />}
                          placeholder="Ex.abc@gmail.com,hotmail.com..."
                        />
                      </Form.Item>
                    </Col>

                    <Col className="gutter-row" span={12}>
                      <Form.Item
                        label="เบอร์โทรศัพท์ผู้ติดต่อ"
                        name="companyPhone"
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: "โปรดระบุ",
                        //   },
                        // ]}
                      >
                        <Input
                          prefix={<PhoneFilled />}
                          placeholder="Ex.080-000-0000"
                        />
                      </Form.Item>
                    </Col>

                    <Col className="gutter-row" span={12}>
                      <Form.Item
                        label="Website"
                        name="companyWebsite"
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: "โปรดระบุ",
                        //   },
                        // ]}
                      >
                        <Input placeholder="Website" />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row gutter={[24, 16]} className="card" style={{ marginTop: 15 }}>
                <Col span={24}>
                  <Heading
                    text={"ข้อมูลผู้ติดต่อ (Contact Person)"}
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                <Col className="gutter-row" span={8}>
                  <Form.Item
                    label="ชื่อ-นามสกุล"
                    name="contactName"
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input placeholder="ชื่อ-นามสกุล" />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={8}>
                  <Form.Item
                    label="ตำแหน่ง"
                    name="contactPosition"
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input placeholder="ตำแหน่ง" />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Row gutter={[16, 16]}>
                    <Col className="gutter-row" span={8}>
                      <Form.Item
                        name="contactEmail"
                        label="Email บริษัท"
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input
                          prefix={<MailFilled />}
                          placeholder="Ex.abc@gmail.com,hotmail.com..."
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col span={24}>
                  <Row gutter={[16, 16]}>
                    <Col className="gutter-row" span={8}>
                      <Form.Item
                        label="เบอร์โทรศัพท์ผู้ติดต่อ"
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input
                          prefix={<MailFilled />}
                          placeholder="Ex.080-000-0000"
                          onChange={(a) => addPhoneNum(a)}
                        />
                        {extraPhoneNumb.length > 0 &&
                          extraPhoneNumb.map((e) => (
                            <div style={{ position: "relative" }}>
                              <Input
                                prefix={<MailFilled />}
                                placeholder="Ex.080-000-0000"
                                style={{ marginTop: 7 }}
                                onChange={(a) => addPhoneNum(a)}
                              />
                              <Button
                                shape="circle"
                                size="small"
                                danger
                                onClick={() => removePhone(e)}
                                style={{
                                  position: "absolute",
                                  right: -35,
                                  top: "30%",
                                  backgroundColor: "#FDE7E5",
                                  border: "#FDE7E5",
                                }}
                              >
                                <DeleteFilled style={{ color: "#F04438" }} />
                              </Button>
                            </div>
                          ))}
                      </Form.Item>
                      {extraPhoneNumb.length < 2 && (
                        <Button
                          type="link"
                          style={{ fontWeight: 600 }}
                          onClick={addPhone}
                        >
                          <PlusOutlined /> เบอร์โทรศัพท์ผู้ติดต่อ
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Col>

                <Col span={24}>
                  <Row gutter={[16, 16]}>
                    <Col className="gutter-row" span={8}>
                      <Form.Item
                        label="สัญชาติ"
                        name="nationalityList"
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        {/* <Select
                          placeholder="กรุณาเลือก"
                          // mode="multiple"
                          onChange={(value) => setCountriesSelect(value)}
                        >
                          {countries.map((item) => (
                            <Option value={item.countryId}>
                              {item.countryNameTh}
                            </Option>
                          ))}
                        </Select> */}
                        <MultipleAutoComplete
                          multiple={false}
                          subject="countryOrderNameTh"
                          valueField="countryId"
                          labelField="countryNameTh"
                          placeholder="กรุณาเลือก"
                          onChange={(value) => setCountriesSelect(value)}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="พื้นที่นิคมฯที่สนใจ/กนอ. แนะนำ"
                    name="areaAuthoritySuggested"
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input.TextArea placeholder="รายละเอียด" />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ความต้องการ/ความคาดหวัง/ความพึงพอใจต่อผลิตภัณฑ์"
                    name="needsSatisfaction"
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input.TextArea placeholder="รายละเอียด" />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ช่องทางที่รู้จัก กนอ. (ตอบได้มากกว่า 1 ข้อ)"
                    name="knownChannel"
                  >
                    <Select
                      mode="multiple"
                      placeholder="กรุณาเลือก"
                      onChange={(value) => onChangeKnownChannel(value)}
                    >
                      {knownChannel.map((item) => (
                        <Option value={item.dataId}>{item.dataDetailTh}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {knownChannelMag === true && (
                    <Form.Item
                      label=""
                      name="knownChannelDetail"
                      style={{ marginTop: 8 }}
                    >
                      <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                    </Form.Item>
                  )}
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ช่องทางที่ใช้ติดต่อ กนอ. ONLINE (ตอบได้มากกว่า 1 ข้อ)"
                    name="knownChannelOnline"
                  >
                    <Select
                      mode="multiple"
                      placeholder="กรุณาเลือก"
                      onChange={(value) => onChangeOn(value)}
                    >
                      {onlineChannel.map((item) => (
                        <Option value={item.dataId}>{item.dataDetailTh}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {onChannelMag === true && (
                    <Form.Item
                      label=""
                      name="knownChannelOnlineDetail"
                      style={{ marginTop: 8 }}
                    >
                      <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                    </Form.Item>
                  )}
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ช่องทางที่ใข้ติดต่อ กนอ. OFFLINE (ตอบได้มากกว่า 1 ข้อ)"
                    name="knownChannelOffline"
                  >
                    <Select
                      mode="multiple"
                      placeholder="กรุณาเลือก"
                      onChange={(value) => onChangeOff(value)}
                    >
                      {offlineChannel.map((item) => (
                        <Option value={item.dataId}>{item.dataDetailTh}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {offChannelMag === true && (
                    <Form.Item
                      label=""
                      name="knownChannelOfflineDetail"
                      style={{ marginTop: 8 }}
                    >
                      <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                    </Form.Item>
                  )}
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="พื้นที่ที่สนใจ"
                    name="interestedArea"
                    // rules={[{ required: true, message: "โปรดระบุ" }]}
                  >
                    <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ความต้องการ/ความคาดหวัง/VOC"
                    name="requirementExpectationVoc"
                    rules={[{ required: true, message: "โปรดระบุ" }]}
                  >
                    <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[24, 16]} className="card" style={{ marginTop: 15 }}>
                <Col span={24}>
                  <Heading
                    text={"สรุปการติดต่อรายครั้ง"}
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                <Form.List name={"contact"}>
                  {(fields, { add, remove }) => {
                    const removeCF = (name) => {
                      setConfirmModal({
                        type: "delete",
                        show: true,
                        name: name,
                      });
                    };
                    const newCF = () => {
                      setContactShowCSS([
                        ...contactShowCSS,
                        { no: contactShowCSS.length + 1, statusShow: false },
                      ]);

                      add();
                    };

                    return (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <Col key={key} span={24}>
                            <div
                              style={{
                                position: "absolute",
                                right: "120px",
                                bottom: "25px",
                              }}
                            >
                              <Button
                                shape="circle"
                                size="small"
                                style={{
                                  backgroundColor: "#FDE7E5",
                                  border: 0,
                                }}
                                onClick={() => removeCF(key)}
                              >
                                <DeleteFilled style={{ color: "#F04438" }} />
                              </Button>
                              <Button
                                shape="circle"
                                size="small"
                                style={{
                                  backgroundColor: "#F4F6FC",
                                  border: 0,
                                  marginLeft: 5,
                                }}
                                onClick={() => collapseElems(key)}
                              >
                                {!contactShowCSS[key].statusShow ? (
                                  <CaretUpFilled
                                    style={{
                                      color: "#2E90FA",
                                      fontSize: 16,
                                    }}
                                  />
                                ) : (
                                  <CaretDownFilled
                                    style={{
                                      color: "#2E90FA",
                                      fontSize: 16,
                                    }}
                                  />
                                )}
                              </Button>
                            </div>
                            <div
                              className={`relative`}
                              style={
                                contactShowCSS[key].statusShow === true
                                  ? style2
                                  : style1
                              }
                            >
                              <Row gutter={[24, 16]}>
                                <Col className="gutter-row" span={12}>
                                  <Form.Item
                                    {...restField}
                                    label="วัน/เดือน/ปี ที่ติดต่อ"
                                    name={[name, "contactDate"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                    <ThaiDatePicker
                                      style={{ width: "100%" }}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={12}>
                                  <Form.Item
                                    {...restField}
                                    label="ชื่อเจ้าหน้าที่"
                                    name={[name, "staffName"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                    <Input placeholder="ชื่อเจ้าหน้าที่" />
                                  </Form.Item>
                                </Col>

                                <Col className="gutter-row" span={24}>
                                  <Form.Item
                                    {...restField}
                                    label="รายละเอียดการติดต่อ"
                                    name={[name, "staffDetail"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                    <Input.TextArea placeholder="รายละเอียด" />
                                  </Form.Item>
                                </Col>

                                <Col span={16}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "upload_file"]}
                                    label={"แนบไฟล์"}
                                    required={true}
                                    rules={[
                                      {
                                        required: true,
                                        message: "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                    <Upload
                                      customRequest={(e) => {
                                        onUploadFile(e, key);
                                      }}
                                      onRemove={(info) => {
                                        onRemoveFile(info, key);
                                      }}
                                      fileList={
                                        fileList.length > 0
                                          ? fileList.filter(
                                              (obj, index) =>
                                                fileList.findIndex(
                                                  (item) =>
                                                    item.uid === obj.uid &&
                                                    item.index === key
                                                ) === index
                                            )
                                          : undefined
                                      }
                                      multiple={false}
                                    >
                                      <Button icon={<UploadOutlined />}>
                                        เลือกไฟล์
                                      </Button>
                                    </Upload>
                                  </Form.Item>

                                  <Col span={24} style={{ paddingTop: 10 }}>
                                    <Text
                                      style={{
                                        fontSize: 14,
                                        fontWeight: 500,
                                        color: "#667085",
                                      }}
                                    >
                                      สามารถ Upload File ได้ 1 File
                                      รองรับนามสกุล JPG, PDF ขนาดไม่เกิน 50 Mb
                                    </Text>
                                  </Col>
                                </Col>

                                <Col className="gutter-row" span={24}>
                                  <Form.Item
                                    {...restField}
                                    label="Note"
                                    name={[name, "staffFollowUp"]}
                                  >
                                    <Input.TextArea placeholder="รายละเอียด" />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        ))}
                        <ConfirmModal
                          actionType={"delete"}
                          title={"ยืนยันการลบข้อมูล"}
                          modalText={"คุณต้องการลบข้อมูล ?"}
                          open={
                            confirmModal.type === "delete"
                              ? confirmModal.show
                              : false
                          }
                          onOk={() => {
                            remove(confirmModal.name);
                            setConfirmModal({
                              type: "",
                              show: false,
                              name: "",
                            });
                          }}
                          onCancel={() => {
                            setConfirmModal({
                              type: "",
                              show: false,
                              name: "",
                            });
                          }}
                        />
                        <Col span={24}>
                          <Button
                            style={{
                              background: "#2E90FA",
                              color: "#fff",
                              fontWeight: 500,
                            }}
                            onClick={() => newCF()}
                          >
                            <PlusOutlined /> เพิ่ม
                          </Button>
                        </Col>{" "}
                      </>
                    );
                  }}
                </Form.List>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>
      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal
        open={failModal}
        setOpen={setFailModal}
        setErrMsg={() => setFailModal(false)}
      />
    </WithSidebar>
  );
};

export default AddStakeholder;
